import { supabase } from './supabase';

/**
 * Solde + derniers versements Stripe du resto (lecture seule), via l'Edge
 * Function `stripe-payouts`. Résilient : renvoie null si la fonction n'est pas
 * déployée / pas de compte connecté / erreur → l'UI masque simplement le bloc.
 */
export interface StripePayout {
  amount_cents: number;
  currency: string;
  /** epoch secondes (date d'arrivée prévue du virement). */
  arrival_date: number;
  status: string;
}
export interface StripePayoutsInfo {
  availableCents: number;
  pendingCents: number;
  currency: string;
  payouts: StripePayout[];
}

export async function loadStripePayouts(tenantId: string): Promise<StripePayoutsInfo | null> {
  try {
    const { data, error } = await supabase.functions.invoke('stripe-payouts', {
      body: { tenant_id: tenantId },
    });
    if (error) return null;
    const r = data as {
      ok?: boolean;
      available_cents?: number;
      pending_cents?: number;
      currency?: string;
      payouts?: StripePayout[];
    } | null;
    if (!r || r.ok !== true) return null;
    return {
      availableCents: r.available_cents ?? 0,
      pendingCents: r.pending_cents ?? 0,
      currency: (r.currency ?? 'eur').toUpperCase(),
      payouts: Array.isArray(r.payouts) ? r.payouts : [],
    };
  } catch {
    return null;
  }
}
